/**
 * UI アイコン。
 *
 * 以前は ⏻ ↺ ✕ ‹ › − ＋ ⟲ といった記号文字を直接置いていたが、
 * スマホの標準フォントに字形が無く豆腐 (文字化け) になるため、すべて SVG にした。
 * フォント依存が無くなるので、どの端末でも同じ見た目になる。
 */
import type { ReactElement } from 'react';

type IconName =
  | 'power'
  | 'refresh'
  | 'close'
  | 'chevronLeft'
  | 'chevronRight'
  | 'chevronUp'
  | 'chevronDown'
  | 'minus'
  | 'plus'
  | 'carry';

const PATHS: Record<IconName, ReactElement> = {
  power: (
    <>
      <path d="M12 3.5v7.5" />
      <path d="M17.2 6.4a7 7 0 1 1-10.4 0" />
    </>
  ),
  refresh: (
    <>
      <path d="M20 12a8 8 0 1 1-2.6-5.9" />
      <path d="M20 4v4.4h-4.4" />
    </>
  ),
  close: (
    <>
      <path d="M6 6l12 12" />
      <path d="M18 6L6 18" />
    </>
  ),
  chevronLeft: <path d="M14.5 5.5L8 12l6.5 6.5" />,
  chevronRight: <path d="M9.5 5.5L16 12l-6.5 6.5" />,
  chevronUp: <path d="M5.5 15L12 8.5l6.5 6.5" />,
  chevronDown: <path d="M5.5 9L12 15.5 18.5 9" />,
  minus: <path d="M6 12h12" />,
  plus: (
    <>
      <path d="M12 6v12" />
      <path d="M6 12h12" />
    </>
  ),
  carry: (
    <>
      <path d="M4.5 12a7.5 7.5 0 1 0 2.4-5.5" />
      <path d="M4 3.6V8h4.4" />
    </>
  ),
};

type Props = { name: IconName; size?: number; strokeWidth?: number };

export function Icon({ name, size = 17, strokeWidth = 1.9 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'block', flex: 'none' }}
    >
      {PATHS[name]}
    </svg>
  );
}
